export const FETCH_LIST_ROLES_FOR_CREATING_ROLES_REQUEST = 'FETCH_LIST_ROLES_FOR_CREATING_ROLES_REQUEST'
export const FETCH_LIST_ROLES_FOR_CREATING_ROLES_SUCCESS = 'FETCH_LIST_ROLES_FOR_CREATING_ROLES_SUCCESS'
export const FETCH_LIST_ROLES_FOR_CREATING_ROLES_FALUIRE = 'FETCH_LIST_ROLES_FOR_CREATING_ROLES_FALUIRE'
